// src/components/inventory/ImagePreviewCell.jsx

import React from 'react';
import { isImageUrl, getGoogleDriveViewUrl, extractGoogleDriveFileId } from '../../utils/driveUtils';

import { PAGE } from '../ui';

export default function ImagePreviewCell({ value }) {
  if (!isImageUrl(value)) {
    return value ? <>{value}</> : <>—</>;
  }

  const viewUrl = getGoogleDriveViewUrl(value);
  const fileId = extractGoogleDriveFileId(value);

  return (
    <button
      type="button"
      onClick={() => window.open(viewUrl, '_blank', 'noopener,noreferrer')}
      style={{
        background: PAGE.colors.info,
        color: '#fff',
        border: 'none',
        borderRadius: 4,
        padding: '4px 8px',
        fontSize: 11,
        fontWeight: 600,
        cursor: 'pointer',
        display: 'inline-block',
      }}
      title={fileId ? `Open image: ${fileId}` : 'Open image'}
    >
      View Image
    </button>
  );
}
